export const predictions = [
  { id: 1, text: 'Черга поруч рухатиметься швидше. І це буде твоя.' },
  { id: 2, text: 'Пісня в навушниках вгадає сьогоднішній настрій' },
  { id: 3, text: 'Ризик гарного дня перевищує допустиму норму.' },
  { id: 4, text: 'Статистика каже: ти ближче до мети, ніж здається.' },
  { id: 5, text: 'Рівень випадкової радості сьогодні вищий за середній.' },
  { id: 6, text: 'Рівень твоєї харизми перевищить денний ліміт на 100%.' },
  { id: 7, text: 'Шанси на приємний сюрприз сьогодні зросли вдвічі' },
  { id: 8, text: 'Велика удача вже близько. Але чай сам себе не зробить' },
  { id: 9, text: 'День обіцяє натхнення. І одну нудну зустріч' },
  { id: 10, text: 'Сьогодні ти підкориш вершину. А потім помиєш чашку.' },
  { id: 11, text: 'Усе складеться чудово. Просто не забудь зарядку.' },
  { id: 12, text: 'Удача вже в дорозі, просто застрягла у ліфті' },
  { id: 13, text: 'Джекпот: сьогодні випадковості гратимуть за тебе.' },
  { id: 14, text: 'Ультрарідкісний бонус: усе встигнеться без паніки.' },
  { id: 15, text: 'Сьогодні випав козир. Використай його красиво.' },
  { id: 16, text: 'Сьогодні доля грає без прихованих комісій.' },
  { id: 17, text: 'Випала кулька швидкого відновлення сил.' },
  { id: 18, text: 'Секретний приз дня: приємна новина без попередження.' },
  { id: 19, text: 'Кулька дня: «Удача пам’ятає твою адресу».' },
  { id: 20, text: 'Запит на диво прийнято. Статус: уже виконується.' },
  { id: 21, text: 'Твою інтуїцію оновлено до останньої версії.' },
  { id: 22, text: 'Сповіщення: твоя присутність сьогодні комусь важлива.' },
  { id: 23, text: 'Файл "гарний день" завантажено без помилок' },
  { id: 24, text: 'Система зафіксувала підвищений рівень удачі' },
  { id: 25, text: 'Статус "усе під контролем" активний до вечора' },
  { id: 26, text: 'Передбачення бачить майбутнє. Там ти усміхаєшся.' },
  { id: 27, text: 'Доля просила передати: далі буде цікавіше.' },
  { id: 28, text: 'Можна не вірити в передбачення. Воно вірить у тебе.' },
  { id: 29, text: 'Ця кулька мала сказати щось мудре. Але каже: ризикни' },
  { id: 30, text: 'Передбачення тут навмисно просте: сьогодні пощастить' },
  { id: 31, text: 'Ця кулька обіцяє знак. Можливо, це і є він.' },
  { id: 32, text: 'Доля вже в дорозі. Кур’єр скоро уточнить адресу.' },
  { id: 33, text: 'Всесвіт надішле повідомлення. Не вимикай сповіщення.' },
  { id: 34, text: 'Сьогодні доля оформила експрес-доставку удачі' },
  { id: 35, text: 'Схоже, ти в чиємусь списку причин усміхнутися.' },
  { id: 36, text: 'Твоя присутність сьогодні змінить чийсь день на краще.' },
  { id: 37, text: 'Хтось запам’ятає твою фразу і ще довго усміхатиметься.' },
  { id: 38, text: 'Твоя ідея потрапить точно туди, де її бракувало.' },
  { id: 39, text: 'Комусь стане спокійніше просто від розмови з тобою.' },
  { id: 40, text: 'Твій погляд на речі сьогодні виявиться дуже доречним.' },
  { id: 41, text: 'Хтось тихо захоплюється тим, як ти тримаєшся.' },
  { id: 42, text: 'Твоя сміливість сьогодні комусь додасть сміливості.' },
  { id: 43, text: 'Комусь дуже потрібен саме твій дивний жарт.' },
  { id: 44, text: 'Хтось вважає зустріч із тобою найкращою частиною дня.' },
  { id: 45, text: 'Твоє «розберемося» сьогодні спрацює магічно.' },
  { id: 46, text: 'Твоя присутність перетворить звичайний момент на теплий.' },
  { id: 47, text: 'Увага, можливі раптові напади гарного настрою.' },
  { id: 48, text: 'Факт дня: твоя харизма сьогодні без обмежень.' },
  { id: 49, text: 'Спостереження: можливий раптовий привід пишатися собою.' },
  { id: 50, text: 'Зірки все знають, але не хочуть псувати сюрприз.' }
];
